import { render, staticRenderFns } from "./TrademarkBulletinAnalyseReportList.vue?vue&type=template&id=b6250528&"
import script from "./TrademarkBulletinAnalyseReportList.vue?vue&type=script&lang=js&"
export * from "./TrademarkBulletinAnalyseReportList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkBulletinAnalyseReportList.vue?vue&type=style&index=0&id=b6250528&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports